import React, {Component} from "react"
import PropTypes from "prop-types"
import styled, {ThemeProvider} from "styled-components"
import isTouchDevice from "is-touch-device"
import classNames from "classnames"
import scrollToElement from "scroll-to-element"
import 'scss/main.scss'
import Seo from "utils/Seo"
import GlobalStyles from "utils/GlobalStyles"
import {useStaticQuery, graphql, StaticQuery} from "gatsby"
import theme from "utils/Theme"
import {LanguageContext} from "utils/LanguageContext"
import SignupModal from "components/shared/SignupModal"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import SocialGlobal from "components/shared/SocialGlobal"
import Cookies from 'universal-cookie'

const cookies = new Cookies();
const COOKIE_DOMAIN = "theworldsstrongestman.com";
// const COOKIE_DOMAIN = "localhost";
let expiry = new Date();
expiry = new Date(expiry.setMonth(expiry.getMonth() + 1))

const SiteWrap = styled.div`
  /* padding-top: 146px; */

  &.noPadding {
    padding-top: 0;
  }
`

class Layout extends Component {
    constructor(props) {
        super(props)
        this.handleFirstTab = this.handleFirstTab.bind(this)

        this.state = {
            open: false
        }
    }

    componentDidMount() {
        // this.bodyPadding()
        this.detectAnchorLinks()
        window.addEventListener('keydown', this.handleFirstTab);
        // if (!cookies.get('signup_open')) {
        //     this.setState({
        //         modalOpen: false,
        //     });
        //
        // }
    }

    handleFirstTab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', this.handleFirstTab);
        }
    }

    // bodyPadding() {
    //     const header = document.getElementsByClassName("headerWrap")[0];
    //     if (header !== undefined) {
    //         const headerHeight = header.clientHeight
    //         document.getElementsByClassName("siteWrap")[0].style.paddingTop = `${headerHeight}px`
    //     }
    // }

    detectAnchorLinks() {
        const header = document.getElementById('siteHeader')
        const hash = window.location.hash.substr(1)
        let headerHeight = 0
        if (header) {
            headerHeight = header.offsetHeight
        }

        // On load
        if (hash !== "") {
            const node = document.getElementById(hash)
            if (node) {
                setTimeout(() => {
                    scrollToElement(node, {
                        offset: -headerHeight,
                        duration: 500
                    });
                }, 1000);
            }
        }

        // On click
        // Grab all links with hash
        const links = document.querySelectorAll('a[href*="#"]');

        // Loop links
        links && Array.prototype.forEach.call(links, link => {
            const id = link.href && link.href.split('#')[1]
            const node = document.getElementById(id)

            if (node) {
                // Add event listener to each
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    scrollToElement(node, {
                        offset: -headerHeight,
                        duration: 500
                    });
                });
            }
        })
    }

    setCookie = () => {
        cookies.set('signup_open', true, {
            expires: expiry,
            domain: COOKIE_DOMAIN
        });
    };


    render() {
        // non multi lang website so default to EN here
        const currentLanguage = {
            code: "EN",
            name: "English",
            slug: "en"
        }
        const defaultLanguage = {
            code: "EN",
            name: "English",
            slug: "en"
        }
        const contextValue = {
            currentLanguage: currentLanguage,
            defaultLanguage: defaultLanguage
        }

        return (
            <LanguageContext.Provider value={contextValue}>
                <ThemeProvider theme={theme}>
                    <Seo
                        seo={this.props.seo}
                        path={this.props.path}
                        language={currentLanguage}
                        // translations={this.props.translations}
                    />
                    <GlobalStyles/>
                    <SiteWrap className={classNames({
                        siteWrap: true,
                        touch: isTouchDevice(),
                        noPadding: !this.props.header
                    })}>
                        {this.props.header &&
                            <Header
                                // translations={this.props.translations}
                                path={this.props.path}
                            />
                        }
                        {this.props.social &&
                            <SocialGlobal/>
                        }
                        <main>{this.props.children}</main>
                        {this.props.footer &&
                            <Footer/>
                        }
                        {/* <NewsletterPopup /> */}
                    </SiteWrap>
                    <StaticQuery
                        query={graphql`
                                query {
                                    allWp {
                                        edges {
                                            node {
                                                ...optionsFragment
                                            }
                                        }
                                    }
                                  }
                              `}
                        render={data => {
                            if (data.allWp.edges[0].node.options.acfOptions.blockSignupPopup.displayingPopup && this.props.path === "/"
                            && !cookies.get('signup_open') && !this.state.open) {
                                return <SignupModal
                                    setCookie={(e) => this.setCookie(e)}
                                    setOpen={(e) => this.setOpen(e)}
                                    simpleWithButton={data.allWp.edges[0].node.options.acfOptions.blockSignupPopup.simpleWithButton}
                                    blockSignupTitle={data.allWp.edges[0].node.options.acfOptions.blockSignupTitle}
                                    blockSignupSubtitle={data.allWp.edges[0].node.options.acfOptions.blockSignupSubtitle}
                                    blockSignupTerms={data.allWp.edges[0].node.options.acfOptions.blockSignupTerms}
                                    blockSignupLink={data.allWp.edges[0].node.options.acfOptions.blockSignupLink}
                                    blockSignupImage={data.allWp.edges[0].node.options.acfOptions.blockSignupImage}
                                />
                            }
                        }}
                    />
                </ThemeProvider>
            </LanguageContext.Provider>
        )
    }
}

export default Layout

// const LayoutExport = (props) => (
//     <StaticQuery
//         query={graphql`
//             query {
//                 allWp {
//                     edges {
//                         node {
//                             defaultLanguage {
//                                 slug
//                                 name
//                                 code
//                             }
//                         }
//                     }
//                 }
//             }
//         `}
//         render={data => <Layout defaultLanguage={data.allWp.edges[0].node.defaultLanguage} {...props} />}
//     />
// )

Layout.defaultProps = {
    header: true,
    footer: true,
    social: true
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}